module.exports = __webpack_public_path__ + "static/media/profile-sample-ktp.a466e5dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/profile-sample-ktp.png
// module id = 654
// module chunks = 8